<template>
  <v-container fluid fill-height class="home-hero" style="max-height: 100vh;">
    <v-layout justify-center align-center column pa-5>
      <div class="display-2 font-weight-black white--text text-xs-center mb-3">
        Chest Injury International Database
      </div>
      <div>
        <v-btn class="login-button" color="white" large outlined to="/login">
          <span class="headline">
            Log in
          </span>
        </v-btn>
      </div>

      <v-card
        max-width="550px"
        class="db-info"
        color="#047AAA"
        dark
        raised
        hover
      >
        <v-card-text>
          The Chest Injury International Database (CIID) is a HIPAA-compliant
          cloud-based data repository for the members of the
          <a href="https://cwisociety.org" target="_blank" class="white--text">
            Chest Wall Injury Society
          </a>
          to support an international research effort. It has been designed by
          thought-leaders from within the society and is maintained by
          <a
            href="https://arcwebtech.com/"
            target="_blank"
            class="white--text"
          >
            Arcweb Technologies </a
          >.
        </v-card-text>
      </v-card>
    </v-layout>
    <div v-if="envLabel" class="env-indicator" :class="{ 'env-production': envLabel === 'production' }">
      <v-icon small :color="envColor">mdi-circle</v-icon>
      <span class="env-label">{{ envLabel }}</span>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'HomeHero',
  computed: {
    envLabel() {
      const url = process.env.VUE_APP_URL || '';
      if (url.includes('app.cwisociety.org')) return 'production';
      if (url.includes('staging')) return 'staging';
      if (url.includes('localhost')) return 'local';
      return 'dev';
    },
    envColor() {
      return this.envLabel === 'production' ? 'grey lighten-1' : 'green';
    }
  }
};
</script>

<style scoped>
.home-hero {
  background: url('/img/skeleton.jpg');
  background-size: cover;
  width: 100%;
  height: 100%;
}
.db-info {
  margin-top: 100px;
}
.env-indicator {
  position: fixed;
  bottom: 12px;
  left: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  opacity: 0.6;
}
.env-production .env-label {
  color: #bdbdbd;
}
.env-label {
  color: green;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
</style>
